import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { NumberSpan } from './BottomInfo';

interface Props {
  title: string;
  children: any;
  initialIsOpen?: boolean;
  theme: any;
  numberOf?: number;
}

function MobileInfoRoller({
  children,
  title,
  initialIsOpen = false,
  theme,
  numberOf,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(initialIsOpen);
  const altText = isOpen ? 'Skryť obsah' : 'Zobraziť obsah';
  return (
    <Wrapper>
      <TitleWrapper
        active={isOpen}
        // tslint:disable-next-line:jsx-no-lambda
        onClick={() => setIsOpen(!isOpen)}
      >
        <Title active={isOpen}>
          {title} {numberOf ? <NumberSpan>{numberOf}</NumberSpan> : null}
        </Title>
        <SvgIcon
          width={24}
          height={24}
          icon={IconType.downArrow}
          alt={altText}
          title={altText}
          fill={theme.colors.textPrimary}
          cursor={'pointer'}
          rotate={isOpen ? 0 : 180}
        />
      </TitleWrapper>
      {isOpen && children}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  padding: ${rem(24)} ${rem(16)};
  margin: 0 -${rem(16)};
`;

const TitleWrapper = styled(FlexRowCenterVertical)<{ active: boolean }>`
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: ${({ active }) => (active ? rem(20) : 0)};
`;

const Title = styled.h3<{ active: boolean }>`
  font-size: ${rem(18)};
  line-height: ${rem(24)};
  font-family: ${({ theme }) => theme.font.secondary};
  margin: 0;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black};
`;

const WithTheme: any = withTheme(MobileInfoRoller);
export { WithTheme as MobileInfoRoller };
